"use client";

import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {SSL_CONSTANTS} from "./constants"; // or wherever your constants are

const SSLCard = () => {
  const {heading, data} = SSL_CONSTANTS;
  const bg = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box
      maxW={"450px"}
      w={"full"}
      bg={bg}
      boxShadow={"lg"}
      borderWidth={"1px"}
      borderRadius="lg"
      borderColor={borderColor}
      p={6}
      h="full"
    >
      <VStack spacing={4} align={"start"}>
        <Heading variant={HeadingVariant} textAlign={"center"}>
          {heading}
        </Heading>
        <Text color={"text.100"}>{data.desc}</Text>
        <Stack spacing={3} pt={4} w="full">
          {data.data.map(({name, pricePerHour, pricePerMonth}, idx) => (
            <Box
              key={idx}
              p={4}
              borderWidth={1}
              borderRadius="md"
              borderColor={borderColor}
            >
              <Text fontWeight="bold" fontSize="lg" mb={2} color="text.100">
                {name}
              </Text>
              <HStack justify={"space-between"}>
                <Text fontWeight="medium">Price per Hour:</Text>
                <Text
                  fontWeight="bold"
                  color={pricePerHour === "FREE" ? "green.500" : "blue.600"}
                >
                  {pricePerHour}
                </Text>
              </HStack>
              <HStack justify={"space-between"} mt={1}>
                <Text fontWeight="medium">Price per Month:</Text>
                <Text
                  fontWeight="bold"
                  color={pricePerMonth === "FREE" ? "green.500" : "blue.600"}
                >
                  {pricePerMonth}
                </Text>
              </HStack>
            </Box>
          ))}
        </Stack>
      </VStack>
    </Box>
  );
};

export default SSLCard;
